import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { http } from '@/api/http';
import { useUIStore } from '@/store/uiStore';
import { getApiErrorMessage } from '@/utils';

export interface NdaTemplate {
  id: string;
  name: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface SignedNda {
  id: string;
  ndaId: string;
  entityType: string;
  entityId: string;
  userId: string;
  createdAt: string;
}

export function useNdas() {
  return useQuery({
    queryKey: ['ndas'],
    queryFn: async () => {
      const res = await http.get('/ndas');
      return res.data?.data || res.data || [];
    },
  });
}

export function useNdaAgreementsList(entityId?: string) {
  return useQuery({
    queryKey: ['nda-agreements-list', entityId],
    queryFn: async () => {
      const res = await http.get('/nda-agreements', { params: { entityId, entityType: 'BusinessTransfer' } });
      return res.data?.data || res.data || [];
    },
  });
}

export function useMySignedNdas() {
  return useQuery({
    queryKey: ['my-signed-ndas'],
    queryFn: async () => {
      const res = await http.get('/nda-agreements');
      return res.data?.data || res.data || [];
    },
  });
}

export function useSignNda() {
  const qc = useQueryClient();
  const { addToast } = useUIStore();

  return useMutation({
    mutationFn: async (payload: { entityType: string; entityId: string; ndaId: string }) => {
      const res = await http.post('/nda-agreements/sign', payload);
      return res.data;
    },
    onSuccess: () => {
      addToast('success', 'Ký NDA thành công!');
      qc.invalidateQueries({ queryKey: ['my-signed-ndas'] });
    },
    onError: (err: any) => {
      addToast('error', getApiErrorMessage(err, 'Đã có lỗi xảy ra khi ký NDA'));
    },
  });
}
